'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('territory', {
                parent: 'entity',
                url: '/territory',
                data: {
                    roles: ['ROLE_ADMIN', 'ROLE_LOCAL_ADMIN'],                    
                    pageTitle: 'lmsApp.territory.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/territory/territory.html',
                        controller: 'TerritoryController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('territory');
                        return $translate.refresh();
                    }]
                }
            })
            .state('territoryDetail', {
                parent: 'entity',
                url: '/territory/:id',
                data: {
                    roles: ['ROLE_ADMIN', 'ROLE_LOCAL_ADMIN'],                    
                    pageTitle: 'lmsApp.territory.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/territory/territory-detail.html',
                        controller: 'TerritoryDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('territory');
                        return $translate.refresh();
                    }]
                }
            });
    });
